module.exports = __webpack_public_path__ + "img/fortune-back.5141f943.png";